<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Venditore' : 'Nuovo Venditore' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-seller-form [data]="data"></app-seller-form>
</div>
